import { ClerkProvider as ClerkProviderBase } from '@clerk/clerk-react'
import { useEffect, type ReactNode } from 'react'

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// Clerk's own dialogs ("confirm it's you") can open from inside an app dialog (`ui/Modal`,
// z-index 10000, same as Clerk's default): keep Clerk's on top.
const clerkAppearance = { elements: { modalBackdrop: { zIndex: 10050 } } }

interface ClerkProviderProps {
  children: ReactNode
}

export function ClerkProvider({ children }: ClerkProviderProps) {
  useEffect(() => {
    if (!publishableKey && import.meta.env.DEV) {
      console.warn(
        '[Hayven] VITE_CLERK_PUBLISHABLE_KEY not set. Auth features disabled.'
      )
    }
  }, [])

  if (!publishableKey) {
    return <MissingClerkConfig />
  }

  return (
    <ClerkProviderBase publishableKey={publishableKey} appearance={clerkAppearance}>
      {children}
    </ClerkProviderBase>
  )
}

function MissingClerkConfig() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 px-6">
      <div className="max-w-lg rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-gray-900">
          Missing Clerk configuration
        </h1>
        <p className="mt-3 text-sm leading-6 text-gray-600">
          Add VITE_CLERK_PUBLISHABLE_KEY to apps/web/.env.local, then restart
          pnpm dev.
        </p>
      </div>
    </main>
  )
}
